import React, { useEffect, useRef } from "react";

import parceiro1 from "../assets/images/parceiro1.png";
import parceiro2 from "../assets/images/parceiro2.png";
import parceiro3 from "../assets/images/parceiro3.png";
import parceiro4 from "../assets/images/parceiro4.png";
import parceiro5 from "../assets/images/parceiro5.png";
import parceiro6 from "../assets/images/ceragon.fw_.png";
import parceiro7 from "../assets/images/Prysmian_Group_Logo-4.png";

import '../styles/partners.css';

const clientLogo = [
  { img: parceiro1 },
  { img: parceiro2 },
  { img: parceiro3 },
  { img: parceiro4 },
  { img: parceiro5 },
  { img: parceiro6 },
  { img: parceiro7 },
];

const Partners = () => {
  const logoContainerRef = useRef(null);

  useEffect(() => {
    const interval = setInterval(() => {
      if (logoContainerRef.current) {
        const firstChild = logoContainerRef.current.firstElementChild;
        logoContainerRef.current.appendChild(firstChild);
      }
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <br />
      <br />
      <h2
        style={{
          textAlign: "center",
          fontSize: "35px",
          fontWeight: "bold",
          margin: "0 15px", // Para dar um pequeno espaçamento nas laterais
        }}
      >
        Nossos Parceiros
      </h2>
      <div
        style={{
          overflow: "hidden",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          height: "250px",
        }}
      >
        <div
          ref={logoContainerRef}
          style={{
            display: "flex",
            gap: "30px", // Aumentei o gap para dar mais espaçamento entre os logos
            animation: "scroll 15s linear infinite", // Aumentei o tempo da animação
          }}
        >
          {clientLogo.map((item, ind) => (
            <div
              key={ind}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "200px",
                height: "200px",
                transition: "transform 0.3s ease-in-out",
              }}
            >
              <img
                src={item.img}
                alt="Parceiro"
                style={{
                  width: "60%",
                  height: "60%",
                  objectFit: "contain",
                }}
              />
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Partners;
